'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import enviro from 'enviro';
import useRecaptcha from './useRecaptcha';
import * as RecaptchaActions from '../../redux/actions/RecaptchaActions';
import { getGoogleActiveLocale } from '../../selectors/LocalizationSelectors';
var keys = {
  qa: '6LfqICUbAAAAADgKeRndAwYmtsX4seIp1AE5XJPC',
  prod: '6LeyEyUbAAAAADz_zRM4Vz9jBhl986CKZN2HMPXP'
};
export default function RecaptchaField() {
  var dispatch = useDispatch(); // use hub-http env check rather than just .getShort() to match localStorage usage for QA custom domains

  var sitekey = keys[enviro.getShort('hub-http')];
  var locale = useSelector(function (state) {
    return getGoogleActiveLocale(state);
  });
  var handleChallengeSuccess = useCallback(function () {
    return dispatch(RecaptchaActions.handleChallengeSuccess.apply(RecaptchaActions, arguments));
  }, [dispatch]);
  var handleRecaptchaExpired = useCallback(function () {
    return dispatch(RecaptchaActions.handleRecaptchaExpired());
  }, [dispatch]);
  var updateWidgetId = useCallback(function (widgetId) {
    return dispatch(RecaptchaActions.updateWidgetId(widgetId));
  }, [dispatch]);
  useRecaptcha({
    sitekey: sitekey,
    onLoad: updateWidgetId,
    onSuccess: handleChallengeSuccess,
    onExpired: handleRecaptchaExpired,
    useRecaptchaEnterprise: true,
    locale: locale,
    baseUrl: 'https://www.google.com/recaptcha'
  });
  return /*#__PURE__*/_jsx("div", {
    className: "m-y-4",
    children: /*#__PURE__*/_jsx("div", {
      id: "hsRecaptchaTarget"
    })
  });
}